import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
import tt from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as et } from "../triggers/triggers-provider-factory.js";
export function openSession() {
  if (!e.rr()) return;
  const i = e.cr();
  if (!i) return;
  i.openSession();
  const t = r.ts.Zt,
    o = new r.es(t, r.j);
  o.hr(t.rs.kr, (e, s) => {
    const n = s.lastClick,
      c = s.trackingString;
    r.j.info(`Firing push click trigger from ${c} push click at ${n}`);
    const g = i.vr(n, c),
      f = function () {
        et.er().be(tt.zr, [c], g);
      };
    i.$r(f, f), o.oe(t.rs.kr, e);
  }),
    o.ss(t.rs.wr, function (r) {
      i.yr(r);
    });
}
